import { Routes } from '@angular/router';
import { authGuard } from './common/guards/auth.guard';
import { guestGuard } from './common/guards/guest.guard';
import { LoginComponent } from './components/login/login.component';
import { RegistrationComponent } from './components/registration/registration.component';
import { InfoComponent } from './components/info/info.component';
import { ResetComponent } from './components/profile/components/reset/reset.component';
import { MemberDetailComponent } from './common/components/member-detail/member-detail.component';
// import { TicketsSoldComponent } from './components/tickets-sold/tickets-sold.component';
import { RfpComponent } from './components/rfp/rfp.component';
import { MagicLinkComponent } from './components/magic-link/magic-link.component';
import { MagicLinkVerifyComponent } from './components/magic-link-verify/magic-link-verify.component';
import { PhoneLoginComponent } from './components/phone-login/phone-login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./components/home/home.component').then((m) => m.HomeComponent),
    data: {
      seo: {
        title: 'Home',
        description: 'Get info',
      },
      footer: true,
    },
  },

  {
    path: 'history',
    loadChildren: () =>
      import('./components/history/history.routes').then(
        (m) => m.historyRoutes,
      ),
    data: {
      seo: {
        title: 'History',
        description: 'Get info about history',
      },
      footer: true,
    },
  },

  {
    path: 'lineup',
    loadChildren: () =>
      import('./components/line-up/line-up.routes').then((m) => m.lineUpRoutes),
    data: {
      seo: {
        title: 'Event Line-Up',
        description: 'Get info about line-up',
      },
      footer: true,
    },
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    component: LoginComponent,
    data: {
      seo: {
        title: 'Log In',
        description: 'Please Log in to your account',
      },
      footer: true,
      headerClose: true,
    },
  },
  {
    path: 'login/magic-link',
    canActivate: [guestGuard],
    component: MagicLinkVerifyComponent,
    data: {
      seo: {
        title: 'Magic Link Verification',
        description: 'Verifying your magic link',
      },
      footer: true,
      headerClose: true,
    },
  },
  {
    path: 'magic-link',
    canActivate: [guestGuard],
    component: MagicLinkComponent,
    data: {
      seo: {
        title: 'Magic Link',
        description: 'Login with magic link',
      },
      footer: true,
      headerClose: true,
    },
  },
  {
    path: 'phone-login',
    canActivate: [guestGuard],
    component: PhoneLoginComponent,
    data: {
      seo: {
        title: 'Phone Login',
        description: 'Login with phone number',
      },
      footer: true,
      headerClose: true,
    },
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./components/profile/profile.routes').then(
        (m) => m.profileRoutes,
      ),
    data: {
      seo: {
        title: 'Log In',
        description: 'Please Log in to your account',
      },
      footer: true,
    },
  },
  {
    path: 'members/:id',
    component: MemberDetailComponent,
    data: {
      seo: {
        title: 'Member Detail',
        description: 'Get info about member',
      },
      footer: true,
    },
  },
  {
    path: 'register',
    canActivate: [guestGuard],
    component: RegistrationComponent,
    data: {
      seo: {
        title: 'Register',
        description: 'Please Register',
      },
      headerClose: true,
      footer: true,
    },
  },
  {
    path: 'reset',
    component: ResetComponent,
    data: {
      seo: {
        title: 'Please Reset Password',
        description: 'Please Reset',
      },
      footer: true,
      headerClose: true,
    },
  },
  {
    path: 'info',
    component: InfoComponent,
    data: {
      seo: {
        title: 'Information',
        description: 'Read Latest Information',
      },
      footer: true,
    },
  },
  // {
  //   path: 'tickets',
  //   component: TicketsSoldComponent,
  //   data: {
  //     seo: {
  //       title: 'Tickets sold',
  //       description: 'Read Latest Information',
  //     },
  //     footer: true,
  //   },
  // },
  {
    path: 'opencall',
    component: RfpComponent,
    data: {
      seo: {
        title: 'Open call',
        description: 'Open call for light installations',
      },
      footer: true,
    },
  },
  {
    path: 'instalations',
    loadChildren: () =>
      import('./components/instalations/instalations.routing').then(
        (m) => m.instalationRoutes,
      ),
    data: {
      seo: {
        title: 'Instalations',
        description: 'Get info about instalations',
      },
      footer: true,
    },
  },
  {
    path: 'schedule',
    loadChildren: () =>
      import('./components/schedule/schedule.routes').then(
        (m) => m.scheduleRoutes,
      ),
    data: {
      seo: {
        title: 'Event Schedule',
        description: 'Get info about schedule',
      },
      footer: true,
    },
  },
];
